import React from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import ProduttivoMuiThemeV2 from '@/components/shared/themes/ProduttivoThemeV2'
import { WorkUserMaps } from '@/javascript/presentation/pages'
import * as Factory from '../usecases'

export const makeWorkUserMaps = () => {
  return(
  <ThemeProvider theme={ProduttivoMuiThemeV2}>
    <WorkUserMaps
      loadAccountMemberList={Factory.makeRemoteLoadAccountMemberList()}
      loadFormList={Factory.makeRemoteLoadFormList()}
      loadProjectList={Factory.makeRemoteLoadProjectList()}
      loadResourcePlaces={Factory.makeRemoteLoadResourcePlaceList()}
      loadWorkFinishOptionList={Factory.makeRemoteLoadWorkFinishOptionList()}
      loadUserLocationList={Factory.makeRemoteLoadUserLocationList()}
      loadWorkLocationList={Factory.makeRemoteLoadWorkLocationList()}
    />
  </ThemeProvider>
  )
}

const maps = document.getElementById('work-team-maps-root')
if (maps !== null) {
  const root = createRoot(maps)
  root.render(makeWorkUserMaps())
}
